export enum ConfigMode {
  PLATFORM = "platform",
  CUSTOMER = "customer",
}
